import { Braces } from 'lucide-react'
import DocumentPreview from './DocumentPreview'
import DocumentSheet from './DocumentSheet'
import type { BusinessProcessVersion } from './types'

export default function SkillSection({ version }: { version: BusinessProcessVersion | null }) {
  return (
    <DocumentSheet
      title="Instruções de execução"
      subtitle="Conteúdo técnico disponibilizado ao agente"
      icon={<Braces className="size-5" />}
    >
      <div className="rounded-lg border bg-muted/40 p-5">
        {version?.skill_markdown ? (
          <>
            {version.agent_summary && (
              <p className="mb-3 whitespace-pre-wrap text-sm text-muted-foreground">{version.agent_summary}</p>
            )}
            <DocumentPreview content={version.skill_markdown} stripFrontmatter variant="skill" testId="skill-preview" />
          </>
        ) : (
          <p className="text-sm text-muted-foreground">
            As instruções aparecerão aqui depois que o agente devolver uma resposta importável.
          </p>
        )}
      </div>
    </DocumentSheet>
  )
}
